import * as React from 'react';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { setRedirectUrl } from '../../../entities/redirect/actions';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';

interface IAuthenticationHocProps {
	sessionToken: string;
	setRedirectUrl: (url: string) => any;
	showModalByDefault?: boolean;
}

export const withAuthentication = (WrappedComponent: React.ComponentType<React.PropsWithChildren<any>>) => {
	const mapStateToProps = (state: IState) => ({
		sessionToken: state.entities.auth.session.current.accessToken,
	});

	const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
		setRedirectUrl: (url: string) => {
			dispatch(setRedirectUrl(url));
		}
	});

	const AuthenticationHoc: React.FC<IAuthenticationHocProps> = (props) => {
		const location = useLocation();
		if (props.sessionToken) {
			return <WrappedComponent {...props} />;
		} else {
			const { search } = location;
			props.setRedirectUrl(encodeURIComponent(location.pathname + location.search));
			return <Navigate to={`/login${search}`} />;
		}
	};

	return connect(mapStateToProps, mapDispatchToProps)(AuthenticationHoc);
};
